<template>
  <div class="animated fadeIn">
      <h4 class="card-title">Administrator <b>Details</b></h4>

      <b-form-row class="form-detail">
        <b-col md="6">
          <b-form-group
                label="Name" label-for="name"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{user.firstName + ' ' + user.lastName }}</label>
          </b-form-group>
          <b-form-group
            label="Phone"
            label-for="phone"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{ user.phone }}</label>
          </b-form-group>
          <b-form-group
                label="Email"
                label-for="email"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{ user.email }}</label>
          </b-form-group>
        </b-col>
      </b-form-row>
      <div slot="footer">
        <b-row>
          <b-col md="6" lg="3" class="d-md-down-none">
            <b-button
                  @click="goBack()"
                  size="md"
                  variant="light"
                  class="btn-pill">
              <i class="fa fa-arrow-left"></i> Back
            </b-button>
          </b-col>
        </b-row>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'userCreate',
  components: {
    axios
  },
  data () {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'profile',
      user: {
        uuid: '',
        firstName: '',
        lastName: '',
        address: '',
        phone: '',
        relation: '',
        email: ''
      }
    }
  },
  mounted () {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo () {
      axios.get(this.apiUrlGetDetail + '/' + this.$route.params.id)
        .then(response => {
          window.setDetailValue(this.user, response.data)
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },

    goBack () {
      window.goBack(this)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/settings/admin/Detail.vue